export default __webpack_public_path__ + "assets/img/avatar-4.49f0b6b.png";